import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import HoldAndWinIntroDialog from "../HoldAndWinIntroDialog/HoldAndWinIntroDialog";
// import HoldAndWinReloadDialog from "../HoldAndWinReloadDialog/HoldAndWinReloadDialog";
import HoldAndWinOutroDialog from "../HoldAndWinOutroDialog/HoldAndWinOutroDialog";
import MaxWinDialog from "../MaxWinDialog/MaxWinDialog";
import FreeSpinIntroDialog from "../FreeSpin/FreeSpinIntroDialog/FreeSpinIntroDialog";
// NOT BUILT (Cleopatra's Fire) — uncomment the import AND its mount below to bring back:
// import FreeSpinOutroDialog from "../FreeSpin/FreeSpinOutroDialog/FreeSpinOutroDialog";
import AdditionalFreeSpinsDialog from "../FreeSpin/AdditionalFreeSpinsDialog/AdditionalFreeSpinsDialog";
import FreeSpinMaxWinDialog from "../FreeSpin/FreeSpinMaxWinDialog/FreeSpinMaxWinDialog";
import FreeSpinTotalWinDialog from "../FreeSpin/FreeSpinTotalWinDialog/FreeSpinTotalWinDialog";
import FreeSpinZeroWinDialog from "../FreeSpin/FreeSpinZeroWinDialog/FreeSpinZeroWinDialog";
// NOT BUILT (Cleopatra's Fire) — uncomment the imports AND their mounts below to bring back:
// import RoyalCollectIntroDialog from "../RoyalCollect/RoyalCollectIntroDialog/RoyalCollectIntroDialog";
// import RoyalCollectOutroDialog from "../RoyalCollect/RoyalCollectOutroDialog/RoyalCollectOutroDialog";
// import PotCollectionIntroDialog from "../PotCollectionIntroDialog/PotCollectionIntroDialog";
// import PotCollectionOutroDialog from "../PotCollectionOutroDialog/PotCollectionOutroDialog";
// import PotCollectionGrandJackpotDialog from "../PotCollectionGrandJackpotDialog/PotCollectionGrandJackpotDialog";
// import PotCollectionMaxWinDialog from "../PotCollectionMaxWinDialog/PotCollectionMaxWinDialog";
// import PotCollectionReloadDialog from "../PotCollectionReloadDialog/PotCollectionReloadDialog";
import TransitionDialog from "../TransitionDialog/TransitionDialog";
// NOT BUILT (Cleopatra's Fire) — uncomment the import AND its mount below to bring back:
// import GambleDialog from "../GambleDialog/GambleDialog";

const Dialogs = () => {
  return (
    <>
      {/* {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinIntroDialog />} */}
      {/* Cleopatra's Respins intro — the FS intro's spine, so the same gate. */}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <HoldAndWinIntroDialog />}
      {/* The mid-feature reload popup — the intro with a variant, as FS does. */}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && (
        <HoldAndWinIntroDialog variant="reload" />
      )}
      {/* Griffin's, on featureGame flags this game never sets: */}
      {/* {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinReloadDialog />} */}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinOutroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <MaxWinDialog />}
      {/* Also mounted for the dev panel. FREE_SPINS.ENABLED is a wide switch —
          it gates assets, sounds, the FreeSpinControl context, the toolbar
          button, the GameContainer reelsets and the scene transition — so it
          is NOT flipped just to look at one popup. */}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && <FreeSpinIntroDialog />}
      {/* The MID-ROUND reload popup. Same spine, same controller, same
          sequence — only the copy ("FREE SPINS / n / LEFT"), the number (spins
          remaining) and the moment differ, so it is this component with a
          variant rather than a second one. Mounted on the same condition as the
          intro for the same reason. */}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && (
        <FreeSpinIntroDialog variant="reload" />
      )}
      {/* NOT BUILT: {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinOutroDialog />} */}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && <AdditionalFreeSpinsDialog />}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && <FreeSpinMaxWinDialog />}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && <FreeSpinTotalWinDialog />}
      {/* Hold & Win's Total Win — the same popup, its own flag and amount. */}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && (
        <FreeSpinTotalWinDialog variant="hold_and_win" />
      )}
      {(FEATURES_CONFIG.FREE_SPINS.ENABLED ||
        FEATURES_CONFIG.DEV_TOOLS.DEV_PANEL) && <FreeSpinZeroWinDialog />}
      {/* NOT BUILT: {FEATURES_CONFIG.ROYAL_COLLECT.ENABLED && <RoyalCollectIntroDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.ROYAL_COLLECT.ENABLED && <RoyalCollectOutroDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionIntroDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionOutroDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionGrandJackpotDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionMaxWinDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionReloadDialog />} */}
      {/* NOT BUILT: {FEATURES_CONFIG.GAMBLE.ENABLED && <GambleDialog />} */}
      <TransitionDialog />
    </>
  );
};

export default Dialogs;
